import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import FileUploader from "../../../components/input/new/fileUploader";
import "./uploadForm.css";
import { useNavigate } from "react-router-dom";
import { authenticatedFetch } from "../../../network/api";

export default function UploadForm({ open, onClose, onNext, fromAppointmentTypeCreation, appointmentDraft, onFormCreatedReturnTo }) {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleFileChange = (files) => {
    setFile(files[0] || null);
    setError("");
  };

  const handleNext = async () => {
    if (!file) {
      setError("Please upload a PDF file.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      const formData = new FormData();
      formData.append("file", file);
      const res = await authenticatedFetch("/api/attorney/webapp/intake/forms/digitizeForm", {
        method: "POST",
        body: formData,
      });
      if (!res.ok) {
        const { error } = await res.json();
        setError(error || "Failed to digitize form.");
        setLoading(false);
        return;
      }
      const data = await res.json();
      if (fromAppointmentTypeCreation && onFormCreatedReturnTo) {
        navigate(onFormCreatedReturnTo, {
          state: {
            newFormId: data.parsed_json.id,
            newFormName: data.parsed_json.name,
            appointmentDraft: appointmentDraft,
          },
        });
      } else if (onNext) {
        onNext(data.parsed_json);
      }
    } catch (err) {
      setError("Something went wrong. Please try again.");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      PaperProps={{
        style: {
          borderRadius: 16,
          padding: 0,
          boxShadow: "0 8px 32px rgba(20,74,140,0.10)",
        },
      }}
    >
      <div className="upload-form-container">
        <div className="upload-form-header-row">
          <div className="upload-form-header-icon">
            <span className="upload-form-header-icon-inner">⬆️</span>
          </div>
          <div>
            <div className="upload-form-header-title">Upload PDF Intake Form</div>
            <div className="upload-form-header-desc">
              Upload your existing intake form PDF. Our AI will digitize it and convert it into a customizable online form.
            </div>
          </div>
        </div>
        <div className="upload-form-section">
          <FileUploader
            accept=".pdf"
            multiple={false}
            onFilesSelected={handleFileChange}
            disabled={loading}
          />
          {error && <div className="upload-form-error">{error}</div>}
        </div>
        <div className="upload-form-footer-row">
          <button
            className="upload-form-next-btn"
            onClick={handleNext}
            disabled={loading}
          >
            {loading ? "Processing..." : "Next"}
          </button>
        </div>
      </div>
    </Dialog>
  );
} 